//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
import { UtilFormTypes } from "models/formTypes";
//#endregion
//#region components
import SendSupplierEmailFormContainer from "./sendEmailFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useSendSupplierEmailDialog(invoiceId: number, onSubmit: () => void, onClose: () => void) {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const getDialog = (emailInfo: UtilFormTypes.Email, emailSuggestions: string[]): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Supplier.EmailDialogHeader),
      titleIcon: IconDefinitionConstants.WEnvelop,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Send),
          successMessage: TranslationKeys.Supplier.EmailSendSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      onClose: onClose,
      onSubmit: onSubmit,
      children: (
        <SendSupplierEmailFormContainer
          invoiceId={invoiceId}
          emailInfo={emailInfo}
          emailSuggestions={emailSuggestions}
        />
      ),
      maxWidth: "sm",
    };
  };

  const showDialog = async (emailInfo: UtilFormTypes.Email, emailSuggestions: string[]) => {
    dispatch(displayDialog(getDialog(emailInfo, emailSuggestions)));
  };

  return { showDialog };
}

export default useSendSupplierEmailDialog;
